import type { ITheme } from "@/types/SharedTypes";
import { createContext, useContext } from "react";

type ThemeContextType = {
    theme: ITheme;
    setTheme: (theme: ITheme) => void;
};

export const ThemeContext = createContext<ThemeContextType>({} as ThemeContextType);

export const useTheme = () => useContext(ThemeContext);